var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var Cookies = require( 'js-cookie' );

var PopUp = function () {
    this.$popUp = $( '.pop-up' );
    this.$popUpClose = $( '.pop-up__close' );
};

PopUp.prototype.init = function () {
    var self = this;
    var timing = self.$popUp.data( 'pop-up-timing' );
    var cookie = Cookies.get( 'pop-up-closed' );

    self.$popUpClose.click( function ( e ) {
        e.preventDefault();
        self.$popUp.removeClass( 'is-open' );
        Cookies.set( 'pop-up-closed', '1', { expires: 7 } );
    } );

    if ( cookie !== '1' ) {
        setTimeout(function () {
            self.$popUp.addClass( 'is-open' );
        }, timing );
    }
};

module.exports = new PopUp();
